import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Fields',
  make: () => ({
    key: [],
    request: (entityTypeKey: string) => ({ http }) =>
      http({
        method: 'GET',
        route: `/fields`,
        query: { returnDisabledFields: true, expand: 'userEditability', entityTypeKey },
      }),
  }),
});
